import React, {Component} from 'react';
import converter from 'number-to-words';
import $ from 'jquery';
import {Title, Pronoun, Nationality} from '../../../../model/Helper';
import PaperSignatories from '../../../../view/PaperSignatories';
import PaperSignatoriesAcknowledgement from '../../../../view/PaperSignatoriesAcknowledgement';
import {blank_line} from '../../../../model/Const';

class Preview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            focus: ".paper-title"
        }
    }

    isVisible(el) {
		var elementTop = $(el).offset().top;
		var elementBottom = elementTop + $(el).outerHeight();
	
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    componentDidMount() {

		$(window).scroll(()=>{

			// This setup will be enabled only with at least md window width
			if($(window).width()>767){
				if(this.isVisible(".header")){
					////console.log("Visible");
					$(".right-preview .preview").css({
						"position": "relative",
						"top": "auto",
						"padding-right": "0"
					});
				} else {
					////console.log("Not visible");
					$(".right-preview .preview").css({
						"position": "fixed",
						"top": "1rem",
						"padding-right": "15px"
					});
				}

			}
        });
        
    }
    
    componentWillReceiveProps(newProps) {
		let ff = newProps.formFocus?newProps.formFocus:'paper-title';

        this.setState({
            focus: '.'+ff
        }, ()=>{
            //console.log(this.state.focus)
            let screenPos = $(window).height()/3;
            let el = $(this.state.focus).length?$(this.state.focus):$(".paper-title");
            let scrollVal = el.get(0).offsetTop-screenPos || 0;
            
            $(".paper").animate({
                scrollTop: scrollVal
            }, 100);
            
        });
    }

    render() {

        let p = this.props.details.property;
        let s = this.props.details.seller;
        let r = this.props.details.representative;

        let blankLine = blank_line;
        //let blankLineLong = "_________________________________";

        let title = (Title(p)) ? Title(p) : blankLine;
        let pAddress = (p.address) ? p.address : blankLine;

        // Natural person variables
        let sellerName = [], 
            sellerSpouseName = [],
            sellerNationality = [],
            sellerAddress = [],
            sellerRepresentativeName = [],
            sellerRepresentativeNationality = [],
            sellerRepresentativeAddress = [],
            sellerTin = [],
            sellerMaritalStatus=[];
        // Corporation variables
        let sellerCorporationName = [],
            sellerCorporationPrincipalPlaceOfBusiness = [],
            sellerCorporationRepresentativeName = [],
            //sellerCorporationRepresentativePosition = [],
            sellerCorporationTin = [];
        this.props.details.seller.forEach((seller, i)=>{
            sellerName[i] = (seller.sellerFname || seller.sellerMname || seller.sellerLname) ? 
                                    (seller.sellerFname+(seller.sellerMname?` ${seller.sellerMname}`:"")+(seller.sellerLname?` ${seller.sellerLname}`:"")+(seller.sellerSuffix?` ${seller.sellerSuffix}`:"")): 
                                    blankLine;
            sellerMaritalStatus[i] = seller.sellerMaritalStatus;
            sellerSpouseName[i] = (seller.sellerSpouseFname || seller.sellerSpouseMname || seller.sellerSpouseLname) ? 
            (seller.sellerSpouseFname+(seller.sellerSpouseMname?` ${seller.sellerSpouseMname}`:"")+(seller.sellerSpouseLname?` ${seller.sellerSpouseLname}`:"")+(seller.sellerSpouseSuffix?` ${seller.sellerSpouseSuffix}`:"")): 
            blankLine;
            sellerNationality[i] = seller.sellerNationality ? seller.sellerNationality : blankLine;
            sellerAddress[i] = seller.sellerAddress ? seller.sellerAddress :  blankLine;
            
            sellerRepresentativeName[i] = (seller.sellerRepresentativeFname || seller.sellerRepresentativeMname || seller.sellerRepresentativeLname) ? 
                                    (seller.sellerRepresentativeFname+(seller.sellerRepresentativeMname?` ${seller.sellerRepresentativeMname}`:"")+(seller.sellerRepresentativeLname?` ${seller.sellerRepresentativeLname}`:"")+(seller.sellerRepresentativeSuffix?` ${seller.sellerRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerRepresentativeNationality[i] = seller.sellerRepresentativeNationality ? seller.sellerRepresentativeNationality : blankLine;
            sellerRepresentativeAddress[i] = seller.sellerRepresentativeAddress ? seller.sellerRepresentativeAddress :  blankLine;
            sellerTin[i] = seller.sellerTin ? seller.sellerTin : "";

            sellerCorporationName[i] = seller.sellerCorporationName ? seller.sellerCorporationName : blankLine;
            sellerCorporationPrincipalPlaceOfBusiness[i] = seller.sellerCorporationPrincipalPlaceOfBusiness ? seller.sellerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            sellerCorporationRepresentativeName[i] = (seller.sellerCorporationRepresentativeFname || seller.sellerCorporationRepresentativeMname || seller.sellerCorporationRepresentativeLname) ? 
                                    (seller.sellerCorporationRepresentativeFname+(seller.sellerCorporationRepresentativeMname?` ${seller.sellerCorporationRepresentativeMname}`:"")+(seller.sellerCorporationRepresentativeLname?` ${seller.sellerCorporationRepresentativeLname}`:"")+(seller.sellerCorporationRepresentativeSuffix?` ${seller.sellerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerCorporationTin[i] = seller.sellerCorporationTin ? seller.sellerCorporationTin : "";
        });

        let representativeName = (r.name || r.mname || r.lname) ? 
            (r.fname+(r.mname?` ${r.mname}`:"")+(r.lname?` ${r.lname}`:"")+(r.suffix?` ${r.suffix}`:"")): 
            blankLine;
        let representativeNationality = r.nationality ? r.nationality : blankLine;
        let representativeAddress = r.address ? r.address :  blankLine;


        let priceNumber = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                                Number(p.price).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2}) :
                                blankLine;		
        let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                            converter.toWords(p.price) : 
                            blankLine;
        
        let areaNumber = (typeof parseFloat(p.area) === "number" && parseFloat(p.area)>0) ?
                            Number(p.area).toLocaleString() :
                            blankLine;		
        let areaText = (typeof parseFloat(p.area) === "number" && parseFloat(p.area)>0) ?
                        converter.toWords(p.area) : 
                        blankLine;

        return (
            <div className="preview">
                <div className="default-preview-fade top"></div>
                <div className="top-preview">
                    <div className="text-center">
                        <p>Preview</p>
                    </div>
                    
                    <div className="paper">
                    <div className="paper-inner">
                        
                        <div className="paper-title text-center">
							Special Power of Attorney<br />
                            <span className="font-weight-normal no-underline">(to sell)</span>
						</div>

                        <div className="text-uppercase">
                            <p className="no-indent">
                                KNOW ALL MEN BY THESE PRESENTS:
                            </p>
                        </div>

                        <div>
                            <p>
                                {
                                    s.map((seller, i)=>{
                                        
                                        return (
                                            <span key={i} className={`d-inline seller_${i}`}>
                                                <span className="d-inline is-natural-person">
                                                    {i>0 && i!==i.length-1?<span>; </span>:""}
                                                    <span className={`dynamic-data font-weight-bold text-uppercase is-married ${sellerMaritalStatus[i]==="Single"?`d-none`:``}`}>{i>0 ? " " : ""}We, SPOUSES</span> <span className={`dynamic-data font-weight-bold text-uppercase seller_sellerFname-${i} seller_sellerMname-${i} seller_sellerLname-${i} seller_sellerSuffix-${i} seller_sellerGender-${i} seller_sellerMaritalStatus-${i}`}>{sellerName[i]}</span><span className={`${sellerMaritalStatus[i]==="Single"?`d-none`:``}`}> and <span className={`dynamic-data font-weight-bold text-uppercase seller_sellerSpouseFname-${i} seller_sellerSpouseMname-${i} seller_sellerSpouseLname-${i} seller_sellerSpouseSuffix-${i}`}>{sellerSpouseName[i]}</span></span>, <span className={`dynamic-data text-capitalize seller_sellerNationality-${i}`}>{Nationality(sellerNationality[i], sellerMaritalStatus[i])}</span>, <span className={`${sellerMaritalStatus[i]==="Single"?`d-none`:``}`}>both </span>of legal age, and with address at <span className={`dynamic-data text-capitalize seller_sellerAddress-${i}`}>{sellerAddress[i]}</span>
                                                </span>
                                            </span>
                                        );
                                        
                                    })
                                }
                                , do hereby APPOINT, NAME and CONSTITUTE <span className="dynamic-data text-capitalize representative_fname representative_mname representative_lname representative_suffix representative_gender">{representativeName}</span>, <span className="dynamic-data text-capitalize representative_nationality">{representativeNationality}</span>, of legal age, and with address at <span className="dynamic-data text-capitalize representative_address">{representativeAddress}</span> to be our true and lawful attorney-in-fact, {sellerMaritalStatus[0]==="Married" ? `for us and in our name` : `for me and in my name`}, place and stead, to do and perform the following acts, deeds and things, to wit;
                                
                            </p>
                        </div>

                        <div>
                            <p>
                                To sell, transfer and convey to whosoever buyer, our real property, covered by <span className="dynamic-data text-uppercase property_ctn property_tct property_oct property_type property_registrationType">{title}</span> (hereinafter "Subject Real Property"), located at <span className="dynamic-data text-capitalize property_address">{pAddress}</span>, and with an area of <span className="dynamic-data text-uppercase property_area">{areaText} ({areaNumber})</span> square meters, amounting to <span className="dynamic-data property_price text-uppercase">{priceText} PESOS (P{priceNumber})</span> Philippine Currency;
                            </p>
                        </div>

                        <div>
                            <p>
                                To accept and collect full payment in {sellerMaritalStatus[0]==="Married" ? `our names` : `my name`}, the proceeds of the sale of the Subject Real Property and sign for the receipt thereof;
                            </p>
                        </div>

                        <div>
                            <p>
                                To pay any and all unpaid or accrued real property taxes including other taxes and miscellaneous expenses, whichever may be applicable, necessary to effect the registration of the sale and the transfer of title of the Subject Real Property to the buyer;
                            </p>
                        </div>

                        <div>
                            <p>
                                To engage the services of a licensed real estate broker, a lawyer, a tax professional, and such other professional real estate practitioners, if necessary, to ensure the expeditious and smooth sale of the property, and to pay their respective fees and/or commissions from the proceeds of the sale; and
                            </p>
                        </div>

                        <div>
                            <p>
                                To do and perform any and all other lawful acts and deeds necessary to undertake the execution and finalization of the sale, transfer, or conveyance of the Subject Real Property.
                            </p>
                        </div>

                        <div>
                            <p>
                                This Special Power of Attorney shall remain valid, binding and effective unless sooner revoked upon written notice to our attorney-in-fact.
                            </p>
                        </div>

                        <div>
                            <p>
                                HEREBY GIVING AND GRANTING unto our said attorney-in-fact full power and authority to do whatsoever requisite, necessary or proper to be done, as fully to all intents and purposes, as {Pronoun("I", s[0].sellerGender, s[0].legalPersonality, s[0].sellerMaritalStatus==="Single"?"seller":"sellers")} might or could lawfully do if personally present, and hereby ratifying and confirming all that our said attorney-in-fact shall do or cause to be done under and by virtue of these presents.
                            </p>
                        </div>

                        <div>
                            <p>
                                IN WITNESS WHEREOF, {Pronoun("I", s[0].sellerGender, s[0].legalPersonality, s[0].sellerMaritalStatus==="Single"?"seller":"sellers")}  have hereunto set our hands this _______________ in _______________, Philippines.    
                            </p>
                        </div>

                        <br />
                        <br />

                        <div>
                            <PaperSignatories party1={s} party2={[]} />
                        </div>
                        
                        <br /><br />
                        <hr />
                        <br /><br />
                        
                        {
                        /**
                         * Acknowledgement section
                         */
                        }
                        <div className="paper-top-left d-inline-block">
							<div>REPUBLIC OF THE PHILIPPINES )</div>
							<div>)S.S.</div>
						</div>

                        <div className="paper-title text-center">
							Acknowledgement
						</div>

                        <div>
                            <p>
                                BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                            </p>
                        </div>

                        <PaperSignatoriesAcknowledgement party1={s} party2={[]} />

                        <div>
                            <p>
                                Known to me and to me known to be the same persons who executed the foregoing Special Power of Attorney consisting of <span className="dynamic-data"><small className="text-muted font-italic">[to be filled up by the system]</small></span> pages, including this page where the acknowledgement is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                            </p>
                            <p>
                                WITNESS MY HAND AND SEAL in the place and on the date first above written.
                            </p>
                        </div>

                        <br />
                        <br />
                        <div className="docno">
							Doc No. ________; <br />
							Page No. _______; <br />
							Book No. _______; <br />
							Series of 20 ___. <br />
						</div>	

                    </div>
                    </div> {/** End of paper */}

                </div>

                <div className="default-preview-fade"></div>
            </div>
        );
    }

}

export default Preview;



// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/special-power-of-attorney-to-sell/Preview.js